import { render, staticRenderFns } from "./user-edit-tab-account.vue?vue&type=template&id=921670cc&"
import script from "./user-edit-tab-account.vue?vue&type=script&lang=ts&"
export * from "./user-edit-tab-account.vue?vue&type=script&lang=ts&"
import style0 from "./user-edit-tab-account.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports